import React from 'react';
import SignUpsV2TabView from './SignUpsV2Tab';
import Loader from '../../../../../../core/components/campaigns/campaigndetails/signupsV2/SignUpsV2DataLoader.js';

// Feature level subroutes
const SignUpsV2Tab = (props) => {
  return (
    <Loader {...props}>
      <SignUpsV2TabView />
    </Loader>
  );
};

export default SignUpsV2Tab;
